module.exports = __webpack_public_path__ + "static/media/Theo-Charles.836deb39.png";